<template>
	<div class="row mb-2">
		<div class="col-2"></div>
		<div class="col-8">
			<div role="group">
				<label for="otpInput" class="fw-500">{{ label }}</label>
				<div class="d-flex">
					<otpInput
						ref="otpInput"
						:input-classes="computedClasses"
						separator=""
						:num-inputs="numInputs"
						:should-auto-focus="true"
						:is-input-num="true"
						@on-change="handleOnChange"
      					@on-complete="handleOnComplete"
					/>
				</div>
			</div>
			<div class="icon-token-login">&nbsp;</div>
		</div>
		<div class="col-2"></div>
	</div>
</template>

<script>
import otpInput from "@bachdgvn/vue-otp-input";
import loginControl from '@/mixins/Login/loginControl';

export default {
	name: 'InputOtp',

	mixins: [
		loginControl
	],

	components: {
		otpInput
	},

	data (){
		return {
			tokens: null,
			codeVerification: null,
		}
	},

	props: {
		fromAuthentication: {
			required: false
		},
		numInputs: {
			required: true
		},
		label: {
			required: true
		}
	},

	watch: {
		tokens(){
			this.$emit('update:updateToken', {
				tokens: this.tokens
			});
		},
		codeVerification(){
			this.$emit('update:updateCodeVerification', {
				codeVerification: this.codeVerification
			});
		},
	},

	computed: {
		computedClasses() {
			return this.numInputs == '6' ? 'otp-input otp-input-six' : 'otp-input otp-input-four';
		}
	},

	mounted(){
		this.tokens = null;
	},

	methods: {
		handleOnComplete(value) {
			this.tokens = value;
			this.codeVerification = value;
		},
		handleOnChange(value) {
			this.tokens = value;
			this.codeVerification = value;
		},
		handleClearInput() {
		this.$refs.otpInput.clearInput();
		},
	},
}
</script>

<style lang="scss" scoped>
	::v-deep .otp-input-six {
		width: 96% !important;
	}

	::v-deep .otp-input-four {
		width: 80% !important;
	}

	::v-deep .otp-input {
		width: 96%;
		height: calc(1.5em + 0.75rem + 10px);
		padding: 0.375rem 1rem;
		font-weight:900;
		border-radius: 0.25rem;
		border: 1px solid #ced4da;
		text-align: center;
	}

	::v-deep .otp-input::-webkit-inner-spin-button,
	.otp-input::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
</style>